import { ref } from 'vue'
import axios from '@/utils/axios'
import useSnackbar, { SnackbarType } from '@/composables/snackbar'

export default function useTrainingPlans() {
  const RESOURCE = '/trainingPlan'
  const { showSnackbar } = useSnackbar()

  const trainingPlans = ref([])
  const isLoading = ref(false)

  const fetchTrainingPlans = async () => {
    isLoading.value = true

    try {
      const response = await axios.get(RESOURCE)
      trainingPlans.value = (response.data || []).map(item => ({
        ...item,
        // eslint-disable-next-line no-underscore-dangle
        id: item.id || item._id,
      }))
    } catch (error) {
      const message = error.response?.data?.message ?? error.message
      showSnackbar(`Failed to fetch training plans: ${message}`, SnackbarType.ERROR)
      throw error
    } finally {
      isLoading.value = false
    }
  }

  const fetchAllTrainingPlans = async () => {
    isLoading.value = true

    try {
      const response = await axios.get(`${RESOURCE}?allAcademies=true`)
      trainingPlans.value = (response.data || []).map(item => ({
        ...item,
        // eslint-disable-next-line no-underscore-dangle
        id: item.id || item._id,
      }))
    } catch (error) {
      const message = error.response?.data?.message ?? error.message
      showSnackbar(`Failed to fetch training plans: ${message}`, SnackbarType.ERROR)
      throw error
    } finally {
      isLoading.value = false
    }
  }

  const deleteTrainingPlan = async id => {
    await axios.delete(`${RESOURCE}/${id}`)
  }

  const updateTrainingPlanCompany = async (trainingPlanIds, companyId) => {
    await axios.put(`${RESOURCE}/company`, { trainingPlanIds, companyId })
  }

  const updateTrainingPlanActive = async (trainingPlanIds, active) => {
    await axios.put(`${RESOURCE}/active`, { trainingPlanIds, active })
  }

  return {
    trainingPlans,
    isLoading,
    fetchTrainingPlans,
    fetchAllTrainingPlans,
    deleteTrainingPlan,
    updateTrainingPlanCompany,
    updateTrainingPlanActive,
  }
}
